export default "__VITE_ASSET__Dk972Yps__"